import PropTypes from 'prop-types';
import {addressConstants} from '../Address';
import {billingConstants} from '../Billing';


// ------ interest
export const CUSTOMER_INTEREST_BUYER = 'buyer';
export const CUSTOMER_INTEREST_SELLER = 'seller';

// order matters: used in registration interest selection
export const CUSTOMER_INTERESTS = [
    CUSTOMER_INTEREST_BUYER,
    CUSTOMER_INTEREST_SELLER
];


// ------ props
export const SHAPE_CUSTOMER_INTEREST = PropTypes.oneOf(CUSTOMER_INTERESTS);

export const SHAPE_CUSTOMER_NAME = PropTypes.string;

export const SHAPE_CUSTOMER = {
    address: addressConstants.SHAPE_ADDRESS,
    billingData: PropTypes.shape(billingConstants.SHAPE_BILLING_DATA),
    interest: SHAPE_CUSTOMER_INTEREST,
    name: SHAPE_CUSTOMER_NAME
};
